import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';
import Select from 'react-select';
import CurrencyInput from 'react-currency-masked-input';
import { FieldList , ClientFormNew, JobForm, FormWizard, Pager, ClientSelect } from '../';
import {
  Tab,
  Nav,
  Row,
  Col,
  NavItem,
  NavDropdown,
  MenuItem,
  Label,
  FormControl,
  FormGroup,
  ControlLabel,
  Radio,
  Well,
  Button,
  ButtonGroup,
} from 'react-bootstrap';

const copy = obj => (JSON.parse(JSON.stringify(obj)));

class ClientNewLead extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab : 0,
      select_client : true,
      creating_client : false,
      creating_lead : false,
      new_client : { address : {} },
      new_lead : {},
    };

    this.handleShouldTab = this.handleShouldTab.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.handlePrevious = this.handlePrevious.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handleFinish = this.handleFinish.bind(this);
    this.handleClientChange = this.handleClientChange.bind(this);
    this.handleLeadChange = this.handleLeadChange.bind(this);
    this.handleSaveClient = this.handleSaveClient.bind(this);
    this.handleCancelCreateClient = this.handleCancelCreateClient.bind(this);
  }

  componentWillMount() {
    this.props.fetchJobsFilters();

    if(this.props.client._id) {
      this.setState({tab : 1});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.client._id && this.state.creating_client) {
      this.setState({tab : 1, select_client : true, creating_client : false, new_client : { address : {}}});
    }
  }
  handleClientChange(value, name) {
    let copy_state = copy(this.state.new_client);
    let entity = copy_state;
    let names = name.split('.');

    while(names.length > 1) {
      let name = names.shift();
      if(!entity[name]) {
        entity[name] = {};
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState({new_client : copy_state});
  }
  handleLeadChange(value, name) {
    let copy_state = copy(this.state.new_lead);
    let entity = copy_state;
    let names = name.split('.');

    while(names.length > 1) {
      let name = names.shift();
      if(!entity[name]) {
        entity[name] = {};
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState({new_lead : copy_state});
  }
  handleSaveClient() {
    this.setState({creating_client : true});
    Api.createClient(this.state.new_client)
    .then(response => {
      this.props.receiveClient(response);
      this.setState({
        tab : 1,
        select_client : true,
        creating_client : false,
        new_client : { address : {}}
      });
    })
    .catch(e => {
      this.setState({
        tab : 0,
        select_client : true,
        creating_client : false,
        new_client : { address : {}}
      });
      this.props.notify({message : e.message || e});
    })
  }
  handleCancelCreateClient() {
    this.setState({
      tab : 0,
      select_client : true,
      creating_client : false,
      new_client : { address : {}}
    });
  }
  handleShouldTab(index) {
    return index != 0 ? this.props.client._id != null : true;
  }
  handleTab(index) {
    this.setState({tab : index});
  }
  handlePrevious() {
    if(this.state.tab > 0) {
      this.setState({ tab : this.state.tab - 1})
    }
  }
  handleNext() {
    switch(this.state.tab) {
      case 0:
        if(!this.props.client._id && this.state.select_client) {
          return this.props.notify({message : 'You must select a valid client.'});
        }
        if(!this.props.client._id) {
          const client = this.state.new_client;
          this.props.addClient(client);
          this.setState({ creating_client : true });
        }
        else {
          if(this.state.tab < 2) {
            this.setState({ tab : this.state.tab + 1 })
          }
        }
        break;
      case 1:
      default:
        break;
    }

  }
  handleFinish() {
    this.props.sendSocketEmit({ job : {...this.state.new_lead, client : this.props.client._id} }, 'create-job');
    this.setState({ creating_lead : false });
  }
  render() {
    if (!this.props.client) {
      return (<div>Loading...</div>);
    }

    // debugger;
    return (
      <div className="row">
        <Col xs={12}>
          <FormWizard.Wizard
            shouldTab={this.handleShouldTab}
            onTab={this.handleTab}
            tab={this.state.tab}
            should_not_tab_err_msg={'You must select a valid client.'}
            >
            <FormWizard.Tab title={this.props.client._id ? `Selected Client: ${this.props.client.name}` : `${this.state.select_client ? 'Select Client' : 'Create Client'}`}>
              {this.state.creating_client ? (
                <div className="text-center"><i className="fa fa-spinner fa-spin"></i> Creating Client</div>
              ) : (
                <div>
                {this.state.select_client ? (
                  <ClientSelect
                    value={this.props.client._id}
                    onChange={option => {
                      if(!option) {
                        return this.props.clearClient();
                      }
                      this.props.fetchClient(option.value)
                    }}
                    options={this.props.client._id ? [{ label : this.props.client.name, value : this.props.client._id }]: []}
                    />
                ) : (
                  <ClientFormNew
                    entity={this.state.new_client}
                    onChange={this.handleClientChange}
                  />
                )}
                </div>
              )}
              {this.state.select_client ? (
                <ButtonGroup className="mt-sm text-center">
                  <Button
                    onClick={e => this.setState({select_client : true})}
                    bsStyle={`${this.state.select_client ? 'primary' : 'default'}`}
                    >
                    Select a Client
                  </Button>
                  <Button
                    onClick={e => this.setState({select_client : false})}
                    bsStyle={`${!this.state.select_client ? 'primary' : 'default'}`}
                    >
                    Create a Client
                  </Button>
                </ButtonGroup>
              ) : (
                <ButtonGroup className="mt-sm text-center">
                  <Button
                    onClick={this.handleCancelCreateClient}
                    bsStyle={`${this.state.select_client ? 'primary' : 'default'}`}
                    >
                    Cancel
                  </Button>
                  <Button
                    onClick={this.handleSaveClient}
                    bsStyle={`${!this.state.select_client ? 'primary' : 'default'}`}
                    >
                    Save New Client
                  </Button>
                </ButtonGroup>
              )}
            </FormWizard.Tab>
            <FormWizard.Tab title="Enter Lead Details">
              {this.state.creating_lead ? (
                <div className="text-center"><i className="fa fa-spinner fa-spin"></i> Creating Client</div>
              ) : ('')}

              <p className="pull-right">
                <strong>* Note: </strong> Additional information can be entered once a lead has been created.
              </p>

              <JobForm entity={this.state.new_lead} onChange={this.handleLeadChange} ref='job_form' />
            </FormWizard.Tab>
          </FormWizard.Wizard>
          {this.state.select_client ? (
            <Pager
              className="mt-sm"
              onPrevious={this.handlePrevious}
              onNext={this.handleNext}
              onFinish={this.handleFinish}
              current={this.state.tab + 1}
              total={2}
            />
          ) : null}
        </Col>
      </div>
    );
  }
}

const mapStateToProps = ({ client, jobs, fields }) => ({ client , jobs, fields });

ClientNewLead.propTypes = {
  client: PropTypes.object.isRequired,
  jobs: PropTypes.object.isRequired
}

export default connect(mapStateToProps, Actions)(ClientNewLead);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-new-lead.js